var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{staticClass:"flexi-tooltip"},[_c('li',{staticClass:"flexi-tooltip--item",class:_vm.isInner ? 'inner' : '',domProps:{"textContent":_vm._s(_vm.tooltip)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }